/* Product reading navigation. Existing Shopify gallery, variant and cart controllers own the purchase. */
(() => {
  const enhance = (scope = document) => {
    const nav = scope.querySelector('.nph28-product-nav') || document.querySelector('.nph28-product-nav');
    if (!nav) return;
    const faq = document.querySelector('.npc-product-faq');
    if (faq && !nav.querySelector('[data-nph32-composition]')) {
      const section = faq.closest('[id]');
      if (section) {
        const link = document.createElement('a');
        link.href = '#' + section.id;
        link.textContent = faq.dataset.nphFactsLabel || 'Innehåll & utfodring';
        link.dataset.nph32Composition = '';
        nav.insertBefore(link, nav.children[1] || null);
      }
    }
    document.querySelectorAll('.npc-product-faq').forEach(facts => {
      if (facts.querySelector('.nph32-fact-index')) return;
      const entries = [...facts.querySelectorAll('details')].filter(d => d.querySelector('summary'));
      if (entries.length < 2) return;
      const index = document.createElement('nav');
      index.className = 'nph32-fact-index';
      index.setAttribute('aria-label', 'Läs produktfakta');
      entries.forEach((details, i) => {
        const summary = details.querySelector('summary');
        if (!details.id) details.id = `${facts.closest('[id]').id}-fact-${i + 1}`;
        const link = document.createElement('a');
        link.href = '#' + details.id;
        link.textContent = summary.textContent.trim();
        link.addEventListener('click', () => {
          details.open = true;
          summary.focus({ preventScroll: true });
        });
        index.append(link);
      });
      const heading = facts.querySelector('.npc-product-faq__head');
      // Keep the reading index inside the heading column; a third grid child displaced the facts.
      heading?.append(index);
    });
  };
  enhance();
  document.addEventListener('shopify:section:load', () => enhance());
})();
